import { explicitMaybe } from '@execonline-inc/decoders';
import { Decoder, field, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../Resource/Decoders';
import { stringOptionsContentDecoder } from '../../components/GenericSortFilter/Decoders';
import { StringOption } from '../../components/Options/Types';
import { GroupsOptions, GroupsOptionsResource } from './Types';

const participantOptionDecoder: Decoder<StringOption> = succeed({})
  .assign('label', field('label', string))
  .assign('value', field('value', string));

const groupsOptionsDecoder: Decoder<GroupsOptions> = succeed({})
  .assign('status', field('status', stringOptionsContentDecoder))
  .assign('loginActivities', field('login_activities', stringOptionsContentDecoder))
  .assign('participant', field('participant', explicitMaybe(participantOptionDecoder)));

export const groupsOptionsResourceDecoder: Decoder<GroupsOptionsResource> =
  resourceDecoder(groupsOptionsDecoder);
